import storage from "@/utils/storage"
import CreatePersistedState from "vuex-persistedstate"

export default CreatePersistedState({
    key: process.env.VUE_APP_PERSISTED_STATE_KEY,
    storage,
})
